<template>
  <div>
    <!-- 标题 -->
    <h1 class="legal_title">
      {{$t("LegalTitle")}}
    </h1>
    <div class="legal_list">
      <ul>
        <li
          v-for="(item, index) in LegalList"
          :key="index"
        >
          <h2
            class="title"
            :class="{'title_icon':item.link!==''}"
            @click="link(item.link,item.id)"
          >
            {{item.title}}
          </h2>
          <div
            class="text"
            v-if="item.text.length>1"
          >
            {{item.text}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    LegalList() {
      return this.$t('LegalList')
    },
  },
  methods: {
    link(link, id) {
      // console.log(1);
      if (link !== '') {
        if (id === '1') {
          window.open(link, '_blank')
        }
        if (id === '2') {
          window.open(link, '_blank')
        }
        if (id === '3') {
          window.open(link, '_blank')
        }
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.legal_title
  font-size: 50px
  font-weight: bold
  line-height: 64px
  margin-top: 100px
  margin-bottom: 60px
.legal_list
  ul
    li
      width: 100%
      padding: 50px
      box-sizing: border-box
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.03)
      .title
        font-weight: bold
        line-height: 25px
        color: #000000
        font-size: 20px
      .title_icon
        position: relative
        padding-right: 40px
        box-sizing: border-box
        display: inline-block
        cursor: pointer
        &::after
          content: ""
          width: 26px
          height: 26px
          display: inline-block
          margin-top: 10px
          background: url('./images/legal-link-icon.png') no-repeat
          position: absolute
          top: 0
          bottom: 0
          right: 0
          margin: 0 auto
      .text
        font-size: 16px
        font-weight: 400
        line-height: 30px
        color: rgba(0,0,0,.6)
        margin-top: 30px
</style>



// WEBPACK FOOTER //
// src/components/legal/legalContent.vue